var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSynPop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 256,
    height: 110,
    viewBox: "0 0 256 110",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "syn"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.34,8.62h10.25c0-10.25,16.81-10.25,16.81,0h10.25",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.61
  }), /*#__PURE__*/React.createElement("line", {
    x1: 128.41,
    y1: 16.06,
    x2: 92.6,
    y2: 16.06,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.61
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.45,47.77s41.96-.82,41.96-.41l18.28-13.43",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.61
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.91,47.5v-5.74c12.19-3.29,20.34-11.17,23.37-24.88",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.34
  }), /*#__PURE__*/React.createElement("line", {
    x1: 110.51,
    y1: 9.09,
    x2: 110.51,
    y2: 15.52,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.34
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "68.41 48.18 68.41 49.82 69.5 50.92 69.5 108.59 108.46 108.73",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.34
  }), /*#__PURE__*/React.createElement("line", {
    x1: 127.59,
    y1: 16.06,
    x2: 163.4,
    y2: 16.06,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.61
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.55,47.77s-41.96-.82-41.96-.41l-18.9-13.43",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.61
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.09,47.5v-5.74c-12.19-3.29-20.34-11.17-23.37-24.88",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.34
  }), /*#__PURE__*/React.createElement("line", {
    x1: 145.49,
    y1: 9.09,
    x2: 145.49,
    y2: 15.52,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.34
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "187.59 48.18 187.59 49.82 186.5 50.92 186.5 108.59 149.94 108.73",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.34
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "109.55 47.98 110.21 48.64 147.68 48.64 147.68 47.47",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.34
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "110.37 58.43 108.83 56.28 108.83 55.05 149.32 55.05 149.32 55.97 147.68 58.43 110.37 58.43",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.34
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.2,58.84c0-4.24-7.79-4.24-7.79,0v17.73h7.79v-17.73Z",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.34
  }), /*#__PURE__*/React.createElement("line", {
    x1: 77.57,
    y1: 76.78,
    x2: 88.74,
    y2: 76.78,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.34
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.14,58.84c0-4.24-7.79-4.24-7.79,0v17.73h7.79v-17.73Z",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.34
  }), /*#__PURE__*/React.createElement("line", {
    x1: 167.5,
    y1: 76.78,
    x2: 178.67,
    y2: 76.78,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.34
  }), /*#__PURE__*/React.createElement("line", {
    x1: 141.22,
    y1: 67.56,
    x2: 148.3,
    y2: 67.56,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.34
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "141.53 68.17 141.94 69.4 141.63 70.63 142.04 70.84 141.53 103.84 145.22 103.84",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.34
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "147.99 68.17 147.58 69.4 147.89 70.63 147.48 70.84 147.99 103.84 144.3 103.84",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.34
  }), /*#__PURE__*/React.createElement("line", {
    x1: 141.63,
    y1: 70.63,
    x2: 147.89,
    y2: 70.63,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.34
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.79,
    y: 103.95,
    width: 9.84,
    height: 5.13,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.34
  }), /*#__PURE__*/React.createElement("line", {
    x1: 116.93,
    y1: 67.56,
    x2: 109.86,
    y2: 67.56,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.34
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "116.62 68.17 116.21 69.4 116.52 70.63 116.11 70.84 116.62 103.84 112.93 103.84",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.34
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "110.16 68.17 110.57 69.4 110.27 70.63 110.68 70.84 110.16 103.84 113.85 103.84",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.34
  }), /*#__PURE__*/React.createElement("line", {
    x1: 116.52,
    y1: 70.63,
    x2: 110.27,
    y2: 70.63,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.34
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.52,
    y: 103.95,
    width: 9.84,
    height: 5.13,
    transform: "translate(226.89 213.02) rotate(-180)",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.34
  }), /*#__PURE__*/React.createElement("line", {
    x1: 111.09,
    y1: 67.15,
    x2: 147.17,
    y2: 67.15,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.34
  }), /*#__PURE__*/React.createElement("line", {
    x1: 110.98,
    y1: 64.28,
    x2: 147.58,
    y2: 64.28,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.34
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111.8,
    y: 48.7,
    width: 34.55,
    height: 18.25,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.34
  }), /*#__PURE__*/React.createElement("line", {
    x1: 109.75,
    y1: 56.79,
    x2: 148.4,
    y2: 56.79,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.97,
    cy: 74.89,
    r: 4.36,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.34
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "128.95 71.31 125.69 76.95 132.2 76.95 128.95 71.31",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "128.95 78.83 132.2 73.19 125.69 73.19 128.95 78.83",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("line", {
    x1: 128,
    y1: 73.42,
    x2: 129.87,
    y2: 76.61,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.27
  }), /*#__PURE__*/React.createElement("line", {
    x1: 127.91,
    y1: 76.75,
    x2: 130,
    y2: 73.38,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.27
  }), /*#__PURE__*/React.createElement("line", {
    x1: 127.18,
    y1: 74.97,
    x2: 131.14,
    y2: 74.97,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.27
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.82,33.15c0-3.64-6.7-3.64-6.7,0v9.29s6.7,0,6.7,0v-9.29Z",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.34
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.06,32.33h1.91c0-6.74,13.26-6.74,13.26,0h1.91",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("line", {
    x1: 95.88,
    y1: 42.58,
    x2: 111.46,
    y2: 42.58,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.66,
    y: 44.36,
    width: 6.56,
    height: 2.46,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("line", {
    x1: 96.56,
    y1: 46.27,
    x2: 96.56,
    y2: 32.47,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("line", {
    x1: 110.92,
    y1: 45.31,
    x2: 110.92,
    y2: 32.6,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.87,33.15c0-3.64,6.7-3.64,6.7,0v9.29s-6.7,0-6.7,0v-9.29Z",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.34
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.62,32.33h-1.91c0-6.74-13.26-6.74-13.26,0h-1.91",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("line", {
    x1: 160.8,
    y1: 42.58,
    x2: 145.22,
    y2: 42.58,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.46,
    y: 44.36,
    width: 6.56,
    height: 2.46,
    transform: "translate(305.48 91.17) rotate(-180)",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("line", {
    x1: 160.12,
    y1: 46.27,
    x2: 160.12,
    y2: 32.47,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("line", {
    x1: 145.77,
    y1: 45.31,
    x2: 145.77,
    y2: 32.6,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.79,89.6c7.93-5.74,15.73-4.91,24.64-.1",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.34
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.97,90.74c-4.35-2.82-8.88-2.43-13.53,0v17.17s13.53,0,13.53,0v-17.17Z",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.31
  }), /*#__PURE__*/React.createElement("line", {
    x1: 119.46,
    y1: 107.84,
    x2: 139.07,
    y2: 107.84,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.34
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.55,41.76c0-2.55-4.78-2.55-4.78,0h5.19",
    fill: "#e77500",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.32,23.99c0-1.64-3.01-1.64-3.01,0v5.88s3.01,0,3.01,0v-5.88Z",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("line", {
    x1: 125.81,
    y1: 30.14,
    x2: 131.96,
    y2: 30.14,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.4,22.9h.82c0-2,5.33-2,5.33,0h1.23",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("line", {
    x1: 125.81,
    y1: 42.72,
    x2: 132.92,
    y2: 42.72,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("line", {
    x1: 126.5,
    y1: 42.85,
    x2: 126.5,
    y2: 43.95,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("line", {
    x1: 132.1,
    y1: 42.85,
    x2: 132.1,
    y2: 43.95,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("line", {
    x1: 130.8,
    y1: 30.77,
    x2: 130.39,
    y2: 30.77,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("line", {
    x1: 127.34,
    y1: 30.77,
    x2: 126.93,
    y2: 30.77,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "95.06 47.91 95.06 49.41 95.74 49.41 95.74 108.32",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "161.49 47.91 161.49 49.41 160.8 49.41 160.8 108.32",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("line", {
    x1: 68.41,
    y1: 49.41,
    x2: 111.46,
    y2: 49.41,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("line", {
    x1: 146.59,
    y1: 49.41,
    x2: 187.59,
    y2: 49.41,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.56,46.82v-3.96c10.52-2.91,18.23-11.34,21.73-24.19h63.96c3.5,12.85,11.22,21.28,21.73,24.19v3.96",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.67
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSynPop);
export default __webpack_public_path__ + "static/media/syn_pop.fc359c91d3a5284a20672cc934cc7568.svg";
export { ForwardRef as ReactComponent };